import { render, staticRenderFns } from "./PickCustomer.vue?vue&type=template&id=5c367ab4&scoped=true&"
import script from "./PickCustomer.vue?vue&type=script&lang=js&"
export * from "./PickCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PickCustomer.vue?vue&type=style&index=0&id=5c367ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c367ab4",
  null
  
)

export default component.exports